<template>
  <div class="consultation">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="70%" @close="handleClose"
      append-to-body>
      <el-container class="container" direction="vertical">
        <el-descriptions :column="4" border>
          <template>
            <el-descriptions-item label="随访类型" span="2">{{ lastPageForm.serviceName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="登记号" span="2">{{ lastPageForm.recordNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="患者姓名" span="2">{{ lastPageForm.patientName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="联系方式" span="2">{{ lastPageForm.phone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="复查项目" span="2">{{ lastPageForm?.examReportInfo?.reportName || '-'
            }}</el-descriptions-item>
            <el-descriptions-item label="复查到期时间" span="2">
              <el-date-picker type="date" placeholder="选择复查时间" v-model="form.reviewExpireTime" :disabled="isRead" style="width:100%"></el-date-picker>
            </el-descriptions-item>
          </template>
          <template>
            <el-descriptions-item label="电话接通情况*" span="4">
              <el-radio v-model="form.followupPhone" label="已接听" :disabled="isRead">已接听</el-radio>
              <el-radio v-model="form.followupPhone" label="未接听" :disabled="isRead">未接听</el-radio>
              <el-radio v-model="form.followupPhone" label="拒接" :disabled="isRead">拒接</el-radio>
              <el-radio v-model="form.followupPhone" label="空号" :disabled="isRead">空号</el-radio>
              <el-radio v-model="form.followupPhone" label="停机" :disabled="isRead">停机</el-radio>
            </el-descriptions-item>
            <el-descriptions-item label="患者依从性*" span="4" v-if="form.followupPhone === '已接听'">
              <el-radio v-model="form.followupObey" label="愿意来院" :disabled="isRead">愿意来院</el-radio>
              <el-radio v-model="form.followupObey" label="拒绝来院" :disabled="isRead">拒绝来院</el-radio>
              <el-radio v-model="form.followupObey" label="未明确" :disabled="isRead">未明确</el-radio>
            </el-descriptions-item>
            <el-descriptions-item label="手术情况" span="2">
              <el-select v-model="form.surgeryName" placeholder="请选择" :disabled="isRead">
                <el-option v-for="(x, index) in surgicalSituationList" :key="index" :label="x.label" :value="x.value" />
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="病理类型" span="2">
              <el-select v-model="form.pathologyName" placeholder="请选择" :disabled="isRead">
                <el-option v-for="(x, index) in pathologicalTypeList" :key="index" :label="x.label" :value="x.value" />
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="备注" span="4">
              <el-input type="textarea" placeholder="请输入内容" v-model="form.annotation" :rows="2"
                :disabled="isRead"></el-input>
            </el-descriptions-item>
          </template>
          <template>
            <el-descriptions-item label="随访信息" span="4">
              <el-descriptions :column="4" border>
                <el-descriptions-item label="随访人" span="2">{{ userInfos?.name || '-' }}</el-descriptions-item>
                <el-descriptions-item label="随访机构" span="2">{{ userInfos?.hospitalName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="随访科室" span="2">{{ userInfos?.deptName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="随访机构电话" span="2">{{ userInfos?.hospitalPhone || '-'
                }}</el-descriptions-item>
                <el-descriptions-item label="随访时间" span="2">{{ userInfos?.codiagTime || '-' }}</el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>
          </template>
        </el-descriptions>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-right: 12px;" type="primary" @click="handleClose">关闭</el-button>
        <!-- <el-button type="primary" v-if="!isRead" @click="handleSubmit">一键随访</el-button> -->

        <el-popconfirm title="是否确认提交？" @confirm="handleSubmit" v-if="!isRead">
          <el-button slot="reference" type="primary">完成通知</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCoDiagDirect, getUserInfos, getSysDicList, getlistClinicItem, getMedicineList } from "@/api/health/Patients";
import { postFollowupNotification } from "@/api/health/Lung";
import moment from "moment";

export default {
  data() {
    return {
      loading1: false,
      loading2: false,
      showDialog: false,
      isRead: false,
      title: "一键随访",
      form: {
        // 电话接听情况
        followupPhone: null,
        // 患者依从性
        followupObey: null,
        // 手术情况
        surgeryName: null,
        // 病理类型
        pathologyName: null,
        // 备注
        annotation: null,
        // 复查时间
        reviewExpireTime: null,
      },
      resetForm: {
        followupPhone: null,
        followupObey: null,
        surgeryName: null,
        pathologyName: null,
        annotation: null,
        reviewExpireTime: null,
      },
      lastPageForm: {},
      userInfos: {},
      // 手术情况数据
      surgicalSituationList: [
        { label: "未手术", value: "未手术" },
        { label: "已手术", value: "已手术" }
      ],
      // 病理类型数据
      pathologicalTypeList: [
        { label: "腺癌", value: "腺癌" },
        { label: "鳞癌", value: "鳞癌" },
        { label: "小细胞肺癌", value: "小细胞肺癌" },
        { label: "大细胞肺癌", value: "大细胞肺癌" },
        { label: "其他", value: "其他" }
      ],
    }
  },
  created() {

  },
  watch: {},
  methods: {
    async init(value) {
      console.warn('肺癌协诊详情', value);
      this.lastPageForm = { ...value };
      this.isRead = value.isRead;
      if (this.isRead) {
        this.title = "随访详情";
        this.form.followupPhone = value.followupPhone;
        this.form.followupObey = value.followupObey;
        this.form.surgeryName = value.surgeryName;
        this.form.pathologyName = value.pathologyName;
        this.form.annotation = value.annotation;
      }
      // 当前复查时间
      this.form.reviewExpireTime = value.reviewExpireTime || null;
      this.getSystemTime();
      getUserInfos({}).then((res) => {
        if (res.msg == "success") {
          this.userInfos.name = res.data.name; // 医师姓名
          this.userInfos.hospitalPhone = res.data.hospitalPhone; // 电话
          this.userInfos.hospitalName = res.data.hospitalName; // 机构
          this.userInfos.deptName = res.data.deptName; // 科室
          this.showDialog = true;
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    setDialogClosed() {
      this.showDialog = false;
    },
    async handleSubmit() {
      console.warn("一键协诊提交：", this.form);
      if (!this.form.followupPhone) {
        this.$message({
          message: "请选择电话接听情况！",
          type: "error"
        })
        return;
      }
      if (!this.form.followupObey && this.form.followupPhone === '已接听') {
        this.$message({
          message: "请选择患者依从性！",
          type: "error"
        })
        return;
      }
      await postFollowupNotification({
        id: this.lastPageForm.id,
        followupPhone: this.form.followupPhone,
        followupObey: this.form.followupObey,
        surgeryName: this.form.surgeryName,
        pathologyName: this.form.pathologyName,
        annotation: this.form.annotation,
        reviewExpireTime: this.form.reviewExpireTime ? this.getStandardDate(this.form.reviewExpireTime) : null
      }).then(res => {
        if (res.msg === 'success') {
          this.$message({
            message: "完成通知成功！",
            type: "success"
          })
          this.$emit("upDataList");
          this.setDialogClosed();
        } else {
          this.$message({
            message: res.msg || "完成通知失败！",
            type: "error"
          })
        }
      }).catch(err => {
        console.log(err);
        this.$message({
          message: err.message || "完成通知失败！",
          type: "error"
        })
      })
    },
    handleClose() {
      this.form = { ...this.resetForm };
      this.setDialogClosed();
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
    },
    getStandardDate(dateString) {
      const formattedDate = moment(dateString).format('YYYY-MM-DD HH:mm');
      return formattedDate;
    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth();
      // 获取日期(1-31)
      var date = time.getDate();
      var hour = time.getHours();
      var minute = time.getMinutes();
      var second = time.getSeconds();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");
      time.setFullYear(year, month, date);
      time.setHours(hour, minute, second);
      this.userInfos.codiagTime = time.Format("yyyy-MM-dd hh:mm:ss"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
    },
  }

}
</script>
<style lang="scss" scoped>
.container {
  height: 500px !important;
  overflow: auto !important;
}
</style>